import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		firstColumnHeader: [{
			text: '#',
			value: '',
			type: '',
			selected: true,
			cssClass: 'rowNumCol',
			sortable: false,
			filterable: false,
			headerScope: 'col',
			dataCssClass: 'rowNum',
		}],
		campaignHeaders: [{
				text: 'Campaign Id',
				value: 'campaignId',
				type: '',
				selected: true,
				cssClass: 'campaignName',
				dataCssClass: 'textColumn',
				sortable: true,
				filterable: true,
				dataScope: 'row',
				onClick: 'showGifts',
				summaryOperation: 'arrayPush',
				skipFiniteCheck: true,
			},
			{
				text: 'List Name',
				value: 'listName',
				type: '',
				selected: true,
				cssClass: 'listText',
				sortable: true,
				filterable: true,
				dataCssClass: 'textColumn'
			},
			{
				text: 'Select',
				value: 'selectList',
				type: '',
				selected: true,
				cssClass: 'selectText',
				sortable: true,
				filterable: true,
				dataCssClass: 'textColumn'
			},
			{
				text: '# Solicited',
				value: 'solicitedNumber',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Start Date',
				value: 'startDate',
				type: 'date',
				selected: true,
				cssClass: 'dateCol',
				sortable: true,
				filterable: true
			},
			{
				text: '# Gifts',
				value: 'numberOfGifts',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$ Gift Amounts',
				value: 'amountOfGifts',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryOperation: 'sum',
			},
			{
				text: 'Response Rate',
				value: 'responseRate',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-2-decimals',
				summaryCalculation: 'Number(row.numberOfGifts)/Number(row.solicitedNumber)',
			},
			{
				text: 'Avg. Gift',
				value: 'avgGift',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryCalculation: 'Number(row.amountOfGifts)/Number(row.numberOfGifts)',
			},
			{
				text: 'In / Out',
				value: 'inOutCost',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'decimal',
				summaryCalculation: 'Number(row.amountOfGifts)/Number(row.totalCost)',
			},
			{
				text: 'Total Cost',
				value: 'totalCost',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryOperation: 'sum',
			},
			{
				text: 'Cost / Piece',
				value: 'costPrice',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryCalculation: 'Number(row.totalCost)/Number(row.solicitedNumber)',
			},
			{
				text: 'Net Cost / Donor',
				value: 'netCost',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryCalculation: '(Number(row.totalCost) - Number(row.amountOfGifts))/Number(row.numberOfGifts)',
			},
			{
				text: '$1,000+',
				value: 'thousandPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$500-$999',
				value: 'fiveHundredPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$250-$499',
				value: 'twoFiftyPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$100-$249',
				value: 'hundredPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$50-$99',
				value: 'fiftyPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$25-$49',
				value: 'twentyFivePlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$1-$24',
				value: 'onePlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Signer',
				value: 'signer',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true
			},
			{
				text: 'Carrier Postage',
				value: 'carrierPostage',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true
			},
			{
				text: 'Carrier Size',
				value: 'carrierSize',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true
			},
			{
				text: 'Reply Postage',
				value: 'replyPostage',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true
			},
			{
				text: 'Double Sided',
				value: 'doubleSided',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true
			},
			{
				text: 'Channel',
				value: 'channel',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true
			},
			{
				text: 'Detail Channel',
				value: 'detailChannel',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true
			},
			{
				text: 'Purpose',
				value: 'purpose',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true
			}
		],
		subtotalHeaders: [{
				text: 'List Name',
				value: 'listName',
				type: '',
				selected: false,
				cssClass: 'listText',
				sortable: true,
				filterable: true,
				dataScope: 'row',
				dataCssClass: 'textColumn',
				onClick: 'redirectToTable',
				summaryOperation: 'arrayPush',
				skipFiniteCheck: true,
			},
			{
				text: 'Select',
				value: 'selectList',
				type: '',
				selected: false,
				cssClass: 'selectText',
				sortable: true,
				filterable: true,
				dataScope: 'row',
				dataCssClass: 'textColumn',
				onClick: 'redirectToTable',
				summaryOperation: 'arrayPush',
				skipFiniteCheck: true,
			},
			{
				text: 'Start Date',
				value: 'startDate',
				type: 'date',
				selected: false,
				cssClass: 'dateCol',
				sortable: true,
				dataScope: 'row',
				filterable: true,
				onClick: 'redirectToTable',
				summaryOperation: 'arrayPush',
				skipFiniteCheck: true,
			},
			{
				text: 'Signer',
				value: 'signer',
				type: '',
				selected: false,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true,
				dataScope: 'row',
				onClick: 'redirectToTable',
				summaryOperation: 'arrayPush',
				skipFiniteCheck: true,
			},
			{
				text: 'Channel',
				value: 'channel',
				type: '',
				selected: false,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true,
				dataScope: 'row',
				onClick: 'redirectToTable',
				summaryOperation: 'arrayPush',
				skipFiniteCheck: true,
			},
			{
				text: 'Detail Channel',
				value: 'detailChannel',
				type: '',
				selected: false,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true,
				dataScope: 'row',
				onClick: 'redirectToTable',
				summaryOperation: 'arrayPush',
				skipFiniteCheck: true,
			},
			{
				text: 'Purpose',
				value: 'purpose',
				type: '',
				selected: false,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true,
				dataScope: 'row',
				onClick: 'redirectToTable',
				summaryOperation: 'arrayPush',
				skipFiniteCheck: true,
			},
			{
				text: 'Master Campaign',
				value: 'masterCampaign',
				type: '',
				selected: false,
				cssClass: 'selectText',
				sortable: true,
				filterable: true,
				dataScope: 'row',
				dataCssClass: 'textColumn',
				onClick: 'redirectToTable',
				summaryOperation: 'arrayPush',
				skipFiniteCheck: true,
			},
			{
				text: '# Solicited',
				value: 'solicitedNumber',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '# Gifts',
				value: 'numberOfGifts',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$ Gift Amounts',
				value: 'amountOfGifts',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryOperation: 'sum',
			},
			{
				text: 'Response Rate',
				value: 'responseRate',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-2-decimals',
				summaryCalculation: 'Number(row.numberOfGifts)/Number(row.solicitedNumber)',
			},
			{
				text: 'Avg. Gift',
				value: 'avgGift',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryCalculation: 'Number(row.amountOfGifts)/Number(row.numberOfGifts)',
			},
			{
				text: 'In / Out',
				value: 'inOutCost',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'decimal',
				summaryCalculation: 'Number(row.amountOfGifts)/Number(row.totalCost)',
			},
			{
				text: 'Total Cost',
				value: 'totalCost',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryOperation: 'sum',
			},
			{
				text: 'Cost / Piece',
				value: 'costPrice',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryCalculation: 'Number(row.totalCost)/Number(row.solicitedNumber)',
			},
			{
				text: 'Net Cost / Donor',
				value: 'netCost',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryCalculation: '(Number(row.totalCost) - Number(row.amountOfGifts))/Number(row.numberOfGifts)',
			},
			{
				text: '$1,000+',
				value: 'thousandPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$500-$999',
				value: 'fiveHundredPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$250-$499',
				value: 'twoFiftyPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$100-$249',
				value: 'hundredPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$50-$99',
				value: 'fiftyPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$25-$49',
				value: 'twentyFivePlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '$1-$24',
				value: 'onePlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			}
		],
		campUpgradeAnalysisHeaders: [{
				text: 'HPC',
				value: 'hpcGifts',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-1-decimal',
				summaryOperation: 'sum',
				summaryCalculation: 'avg',
			},
			{
				text: 'Upgrade',
				value: 'upgradeGifts',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-1-decimal',
				summaryOperation: 'sum',
				summaryCalculation: 'avg',
			},
			{
				text: 'Downgrade',
				value: 'downgradeGifts',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-1-decimal',
				summaryOperation: 'sum',
				summaryCalculation: 'avg',
			}
		],
		campEmailAnalysisHeaders: [{
				text: 'Active',
				value: 'activeEmail',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Disengaged',
				value: 'disengagedEmail',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Bounced',
				value: 'bouncedEmail',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'No Email',
				value: 'noEmail',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			}
		],
		campPercentColumnHeaders: [{
				text: '$1,000+ %',
				value: 'percentThousandPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-1-decimal',
				calculatedColumnOf: 'thousandPlusDonor',
				summaryCalculation: 'row.thousandPlusDonor/row.numberOfGifts'
			},
			{
				text: '$500-$999 %',
				value: 'percentFiveHundredPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-1-decimal',
				calculatedColumnOf: 'fiveHundredPlusDonor',
				summaryCalculation: 'row.fiveHundredPlusDonor/row.numberOfGifts'
			},
			{
				text: '$250-$499 %',
				value: 'percentTwoFiftyPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-1-decimal',
				calculatedColumnOf: 'twoFiftyPlusDonor',
				summaryCalculation: 'row.twoFiftyPlusDonor/row.numberOfGifts'
			},
			{
				text: '$100-$249 %',
				value: 'percentHundredPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-1-decimal',
				calculatedColumnOf: 'hundredPlusDonor',
				summaryCalculation: 'row.hundredPlusDonor/row.numberOfGifts'
			},
			{
				text: '$50-$99 %',
				value: 'percentFiftyPlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-1-decimal',
				calculatedColumnOf: 'fiftyPlusDonor',
				summaryCalculation: 'row.fiftyPlusDonor/row.numberOfGifts'
			},
			{
				text: '$25-$49 %',
				value: 'percentTwentyFivePlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-1-decimal',
				calculatedColumnOf: 'twentyFivePlusDonor',
				summaryCalculation: 'row.twentyFivePlusDonor/row.numberOfGifts'
			},
			{
				text: '$1-$24 %',
				value: 'percentOnePlusDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent-1-decimal',
				calculatedColumnOf: 'onePlusDonor',
				summaryCalculation: 'row.onePlusDonor/row.numberOfGifts'
			}
		],
		campSubsequentAnalysisHeaders: [{
				text: 'Subsequent $ Gift',
				value: 'subsequentGiftsDollar',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryOperation: 'sum',
			},
			{
				text: 'Subsequent Expenses',
				value: 'subsequentExpenses',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryOperation: 'sum',
			},
			{
				text: 'Subsequent # Gift',
				value: 'subsequentGiftsCount',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Subsequent # Mail Solicitation',
				value: 'subsequentMail',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Subsequent # E-Mail Solicitation',
				value: 'subsequentEmail',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Subsequent Avg. Gift',
				value: 'subsequentAvgGift',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryCalculation: 'row.subsequentGiftsDollar/row.subsequentGiftsCount',
			},
			{
				text: 'Subsequent In / Out',
				value: 'subsequentInOut',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'decimal',
				summaryCalculation: 'row.subsequentGiftsDollar/row.subsequentExpenses',
			},
			{
				text: '3-Month Donor',
				value: 'threeMonthDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '3-Month Retention Rate',
				value: 'threeMonthRetentionRate',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent',
				summaryCalculation: 'row.threeMonthDonor/row.numberOfGifts',
			},
			{
				text: '6-Month Donor',
				value: 'sixMonthDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '6-Month Retention Rate',
				value: 'sixMonthRetentionRate',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent',
				summaryCalculation: 'row.sixMonthDonor/row.numberOfGifts',
			},
			{
				text: '9-Month Donor',
				value: 'nineMonthDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '9-Month Retention Rate',
				value: 'nineMonthRetentionRate',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent',
				summaryCalculation: 'row.nineMonthDonor/row.numberOfGifts',
			},
			{
				text: '12-Month Donor',
				value: 'twelveMonthDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '12-Month Retention Rate',
				value: 'twelveMonthRetentionRate',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'percent',
				summaryCalculation: 'row.twelveMonthDonor/row.numberOfGifts',
			},
			{
				text: 'Combined Gifts',
				value: 'combinedGifts',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryOperation: 'sum',
			},
			{
				text: 'Combined Expenses',
				value: 'combinedExpenses',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryOperation: 'sum',
			},
			{
				text: 'Combined Net Profit',
				value: 'combinedNetProfit',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency-no-decimals',
				summaryCalculation: 'row.combinedGifts - row.combinedExpenses',
			},
			{
				text: 'Combined In / Out',
				value: 'combinedInOut',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'decimal',
				summaryCalculation: 'row.combinedGifts/row.combinedExpenses',
			},
			{
				text: '# Direct Mail Donors',
				value: 'directMailChannelDonar',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: '# Digital Donors',
				value: 'digitalChannelDonar',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Email Donor',
				value: 'emailDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Social Donor',
				value: 'socialDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Organic Donor',
				value: 'organicDonor',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			}
		],
		giftHeaders: [{
				text: 'Constituent Id',
				value: 'constituentId',
				type: '',
				selected: true,
				cssClass: 'campaignName',
				sortable: true,
				filterable: true,
				dataCssClass: 'textColumn'
			},
			{
				text: 'Account Name',
				value: 'accountName',
				type: '',
				selected: true,
				cssClass: 'longText',
				sortable: true,
				filterable: true,
				dataCssClass: 'textColumn'
			},
			{
				text: 'Campaign Id',
				value: 'campaignName',
				type: '',
				selected: true,
				cssClass: 'campaignName',
				dataCssClass: 'textColumn',
				sortable: true,
				filterable: true,
			},
			{
				text: 'Gift Date',
				value: 'giftDate',
				type: 'date',
				selected: true,
				cssClass: 'dateCol',
				sortable: true,
				filterable: true
			},
			{
				text: 'Gift Amount',
				value: 'giftAmount',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryOperation: 'sum',
			},
			{
				text: 'UTM Source',
				value: 'utmSource',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true,
				dataCssClass: 'textColumn'
			},
			{
				text: 'UTM Content',
				value: 'utmContent',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true,
				dataCssClass: 'textColumn'
			},
			{
				text: 'UTM Campaign',
				value: 'utmCampaign',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true,
				dataCssClass: 'textColumn'
			},
			{
				text: 'UTM Medium',
				value: 'utmMedium',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true,
				dataCssClass: 'textColumn'
			},
			{
				text: 'Previous Gifts',
				value: 'previousGifts',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Status',
				value: 'status',
				type: '',
				selected: true,
				cssClass: 'campaignData',
				sortable: true,
				filterable: true
			}
		],
		giftUpgradeAnalysisHeaders: [{
				text: 'HPC',
				value: 'hpcGifts',
				type: '',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				summaryOperation: 'sumText',
				summaryValues: ['Yes'],
			},
			{
				text: 'Upgrade',
				value: 'upgradeGifts',
				type: '',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				summaryOperation: 'sumText',
				summaryValues: ['Yes'],
			},
			{
				text: 'Downgrade',
				value: 'downgradeGifts',
				type: '',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				summaryOperation: 'sumText',
				summaryValues: ['Yes'],
			}
		],
		giftEmailAnalysisHeaders: [{
				text: 'Active',
				value: 'activeEmail',
				type: '',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				summaryOperation: 'sumText',
				summaryValues: ['Yes'],
			},
			{
				text: 'Disengaged',
				value: 'disengagedEmail',
				type: '',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				summaryOperation: 'sumText',
				summaryValues: ['Yes'],
			},
			{
				text: 'Bounced',
				value: 'bouncedEmail',
				type: '',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				summaryOperation: 'sumText',
				summaryValues: ['Yes'],
			},
			{
				text: 'No Email',
				value: 'noEmail',
				type: '',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				summaryOperation: 'sumText',
				summaryValues: ['Yes'],
			}
		],
		giftSubsequentGivingHeaders: [{
				text: 'Subsequent $ Gifts',
				value: 'subsequentGiftDollar',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryOperation: 'sum',
			},
			{
				text: 'Subsequent Expenses',
				value: 'subsequentExpenses',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryOperation: 'sum',
			},
			{
				text: 'Subsequent # Gifts',
				value: 'subsequentGiftCount',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Subsequent # Mail Solicitation',
				value: 'subsequentMail',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Subsequent Avg. Gift',
				value: 'subsequentGiftAvg',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryCalculation: 'row.subsequentGiftDollar/row.subsequentGiftCount',
			},
			{
				text: 'Subsequent In/Out',
				value: 'subsequentInOut',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'decimal',
				summaryCalculation: 'row.subsequentGiftDollar/row.subsequentExpenses',
			},
			{
				text: 'Combined Gifts',
				value: 'combinedGifts',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'number',
				summaryOperation: 'sum',
			},
			{
				text: 'Combined Expenses',
				value: 'combinedExpenses',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryOperation: 'sum',
			},
			{
				text: 'Combined Net Profit',
				value: 'combinedNetProfit',
				type: 'number',
				selected: true,
				cssClass: 'numberCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'currency',
				summaryCalculation: 'row.combinedGifts - row.combinedExpenses',
			},
			{
				text: 'Combined In/Out',
				value: 'combinedInOut',
				type: 'number',
				selected: true,
				cssClass: 'shortNumCol',
				sortable: true,
				filterable: true,
				dataCssClass: 'numStyle',
				dataFormatter: 'decimal',
				summaryCalculation: 'row.combinedGifts/row.combinedExpenses',
			}
		],
		lookups: new Map()

	},
	getters: {
		getCachedLookup: (state) => (endpoint) => {
			return state.lookups.get(endpoint);
		}
	},
	mutations: {
		updateSubtotalHeaderSelected(state, payload) {

			payload.colVal.forEach(col => {
				state.subtotalHeaders = state.subtotalHeaders.map(obj => obj.value == col.valueKey ? {
					...obj,
					selected: true
				} : obj);
			});

		},
		cacheLookup(state, payload) {
			state.lookups.set(payload.endpoint, payload.data);
		}
	},
	actions: {}
});

export default store;
